import { useEffect } from 'react';
import useDebounce from 'src/hooks/useDebounce/useDebounce';
import { TSearchUsersToAddProgramGroupRequest } from 'src/services/apiEndpoint.types.ts';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {
  resetSearchUsersToAddIdeaGroupSuccess,
  searchUsersToAddProgramGroup
} from 'src/store/chat/chat.slice';

import { TUseGetProgramGroupUsersProps } from './manageProgramGroupMembers.types';

const useGetProgramGroupUsers = ({
  programId,
  groupId,
  filterString
}: TUseGetProgramGroupUsersProps) => {
  // Hooks
  const dispatch = useAppDispatch();
  const { searchUsersToAddProgramGroupPageNumber, searchUsersToAddProgramGroupItemsPerPage } =
    useAppSelector((store) => store.chat);

  const getUsers = ({ resetUsers }: { resetUsers: boolean }) => {
    if (filterString) {
      const payload: TSearchUsersToAddProgramGroupRequest = {
        programId,
        programConversationId: groupId,
        filterString,
        limit: searchUsersToAddProgramGroupItemsPerPage,
        offset: resetUsers ? 1 : searchUsersToAddProgramGroupPageNumber
      };

      dispatch(searchUsersToAddProgramGroup(payload));
    } else {
      dispatch(resetSearchUsersToAddIdeaGroupSuccess());
    }
  };

  useDebounce({
    func: () => getUsers({ resetUsers: true }),
    delay: 500,
    dependency: filterString
  });

  useEffect(() => {
    getUsers({ resetUsers: false });
  }, [searchUsersToAddProgramGroupPageNumber]);

  return getUsers;
};

export default useGetProgramGroupUsers;
